import { EditThreshold } from './ModalAndTrigger'

export default EditThreshold
